<template>
    <v-navigation-drawer
        app
        floating
        :mobile-breakpoint="$vuetify.breakpoint.thresholds.sm"
        :value="value"
        :mini-variant="isCollapsed"
        mini-variant-width="72"
        class="ordit-navigation-drawer"
        @input="$emit('input', $event)"
    >
        <template v-slot:prepend>
            <div
                class="ordit-navigation-drawer__head d-flex align-center px-6 pt-6 pb-2"
            >
                <router-link v-if="!isCollapsed" :to="ordersRoute">
                    <ordit-logo width="80px"></ordit-logo>
                </router-link>
                <v-spacer v-if="!isCollapsed"></v-spacer>
                <v-btn
                    v-if="$vuetify.breakpoint.mdAndUp"
                    icon
                    small
                    class="ordit-navigation-drawer__toggle"
                    :class="{ 'is-collapsed': isCollapsed }"
                    :aria-label="
                        isCollapsed
                            ? 'Expand navigation'
                            : 'Collapse navigation'
                    "
                    @click="toggleCollapsed"
                >
                    <!-- the merchant portal nav's collapse icon (Sales page): a filled 16px
                         double chevron; collapsed it points the other way -->
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        aria-hidden="true"
                    >
                        <path
                            d="M7.45711 4.70711C7.84763 4.31658 7.84763 3.68342 7.45711 3.29289C7.06658 2.90237 6.43342 2.90237 6.04289 3.29289L2.04289 7.29289C1.85536 7.48043 1.75 7.73479 1.75 8C1.75 8.26522 1.85536 8.51957 2.04289 8.70711L6.04289 12.7071C6.43342 13.0976 7.06658 13.0976 7.45711 12.7071C7.84763 12.3166 7.84763 11.6834 7.45711 11.2929L4.16421 8L7.45711 4.70711Z"
                            fill="currentColor"
                        ></path>
                        <path
                            d="M12.9571 4.70711C13.3476 4.31658 13.3476 3.68342 12.9571 3.29289C12.5666 2.90237 11.9334 2.90237 11.5429 3.29289L7.54289 7.29289C7.35536 7.48043 7.25 7.73478 7.25 8C7.25 8.26522 7.35536 8.51957 7.54289 8.70711L11.5429 12.7071C11.9334 13.0976 12.5666 13.0976 12.9571 12.7071C13.3476 12.3166 13.3476 11.6834 12.9571 11.2929L9.66421 8L12.9571 4.70711Z"
                            fill="currentColor"
                        ></path>
                    </svg>
                </v-btn>
            </div>
        </template>

        <VuePerfectScrollbar>
            <v-list flat class="ordit-nav">
                <v-list-item-group v-model="current">
                    <div
                        v-if="isCompanyAdmin && !isCollapsed"
                        class="mb-2 text-center"
                    >
                        <v-btn
                            color="primary"
                            class="white--text align-self mb-1"
                            depressed
                            :href="`${FeBaseURL}/restaurants`"
                            target="_blank"
                            >{{ $t('labels.order_now') }}</v-btn
                        >
                    </div>
                    <div v-for="(item, i) in sidebarMenu" :key="i">
                        <v-list-item
                            v-if="!item.children"
                            :to="item.route"
                            :title="
                                isCollapsed
                                    ? item.notrans || $t(item.title)
                                    : null
                            "
                            color="primary"
                        >
                            <v-list-item-icon>
                                <web2-icon
                                    :name="item.icon"
                                    :size="24"
                                ></web2-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>
                                    {{ item.notrans || $t(item.title) }}
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-group
                            v-else
                            :title="isCollapsed ? $t(item.title) : null"
                            @click="expandSidebar"
                        >
                            <template v-slot:prependIcon>
                                <web2-icon
                                    :name="item.icon"
                                    :size="24"
                                ></web2-icon>
                            </template>
                            <template v-slot:appendIcon>
                                <web2-icon
                                    name="chevron-down-nav"
                                    :size="16"
                                ></web2-icon>
                            </template>
                            <template v-slot:activator>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        {{ $t(item.title) }}
                                    </v-list-item-title>
                                </v-list-item-content>
                            </template>
                            <template v-slot:default>
                                <v-list-item
                                    v-for="(citem, j) in item.children"
                                    :key="j"
                                    :to="citem.route"
                                    color="primary"
                                >
                                    <v-list-item-content
                                        class="ordit-nav__child"
                                    >
                                        <v-list-item-title>
                                            {{
                                                citem.fallback &&
                                                !$te(citem.title)
                                                    ? citem.fallback
                                                    : $t(citem.title)
                                            }}
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </template>
                        </v-list-group>
                    </div>
                    <div
                        v-if="otterLinkRouteLinks.length && !isCollapsed"
                        class="mt-2 text-center"
                    >
                        <v-tooltip
                            v-if="otterLinkRouteLinks.length === 1"
                            bottom
                        >
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    color="primary"
                                    class="white--text align-self"
                                    depressed
                                    :href="otterLinkRouteLinks[0].url"
                                    target="_blank"
                                    v-on="on"
                                >
                                    {{ $t('labels.connect_otter') }}
                                </v-btn>
                            </template>
                            <span>
                                {{ $t('labels.connect') }}:
                                {{ otterLinkRouteLinks[0].name }}
                            </span>
                        </v-tooltip>
                        <v-menu v-else offset-y>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    color="primary"
                                    class="white--text align-self"
                                    v-on="on"
                                >
                                    {{ $t('labels.connect_otter') }}
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-item
                                    v-for="(item, index) in otterLinkRouteLinks"
                                    :key="index"
                                >
                                    <v-list-item-title>
                                        <v-btn
                                            :href="item.url"
                                            target="_blank"
                                            plain
                                            text
                                        >
                                            {{ $t('labels.connect') }}:
                                            {{ item.name }}
                                        </v-btn>
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </div>
                </v-list-item-group>
            </v-list>
        </VuePerfectScrollbar>

        <template v-slot:append>
            <div class="ordit-navigation-drawer__account">
                <!-- opens above the button, on its edges (it sat 16px to the right of the button;
                     sweep 2026-11-04); 220px wide over the collapsed drawer -->
                <v-menu
                    v-model="accountMenu"
                    top
                    offset-y
                    nudge-top="4"
                    :min-width="isCollapsed ? 220 : undefined"
                    content-class="ordit-account-menu"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <button
                            type="button"
                            class="ordit-account-pill"
                            :title="isCollapsed ? name : null"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <web2-icon name="account" :size="24"></web2-icon>
                            <template v-if="!isCollapsed">
                                <span class="ordit-account-pill__name">
                                    {{ name }}
                                </span>
                                <web2-icon
                                    name="chevron-down-nav"
                                    :size="16"
                                ></web2-icon>
                            </template>
                        </button>
                    </template>
                    <div role="menu">
                        <router-link
                            v-if="!isRestaurantAdmin"
                            role="menuitem"
                            class="ordit-account-menu__item"
                            :to="{
                                name: routeType.USER_EDIT,
                                params: { userId },
                            }"
                        >
                            <web2-icon name="employees" :size="24"></web2-icon>
                            <span>{{ $t('labels.profile_details') }}</span>
                        </router-link>
                        <button
                            type="button"
                            role="menuitem"
                            class="ordit-account-menu__item"
                            @click="logout"
                        >
                            <web2-icon name="logout" :size="24"></web2-icon>
                            <span>{{ $t('auth.logout') }}</span>
                        </button>
                    </div>
                </v-menu>
            </div>
        </template>
    </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import OrditLogo from './OrditLogo.vue'
import Web2Icon from '@/components/elements/Web2Icon.vue'
import AuthMixin from '@/components/mixins/AuthMixin'
import MenuMixin from '../mixins/Menu'
import routeType from '@/router/routeType'
import authType from '@/store/type/authType'
import restaurantType from '@/store/type/restaurantType'
import Config from '@/config.loader'

const COLLAPSED_STORAGE_KEY = 'ordit.sidebarCollapsed'

function readCollapsed() {
    try {
        return window.localStorage.getItem(COLLAPSED_STORAGE_KEY) === '1'
    } catch (e) {
        return false
    }
}

function writeCollapsed(collapsed) {
    try {
        window.localStorage.setItem(
            COLLAPSED_STORAGE_KEY,
            collapsed ? '1' : '0'
        )
    } catch (e) {
        // the state is a convenience only
    }
}

export default {
    components: {
        VuePerfectScrollbar,
        OrditLogo,
        Web2Icon,
    },
    mixins: [AuthMixin, MenuMixin],
    props: {
        value: {
            type: Boolean,
            default: null,
        },
    },
    data() {
        return {
            current: null,
            collapsed: readCollapsed(),
            accountMenu: false,
            routeType,
            FeBaseURL: Config.getConfigValue('VUE_APP_PUBLIC_FE_BASE'),
            BeBaseURL: Config.getConfigValue('VUE_APP_BACKEND_BASE'),
        }
    },
    computed: {
        ...mapGetters({
            userId: authType.getters.USER_ID,
            name: authType.getters.GET_EMAIL,
            restaurant: restaurantType.getters.ACTIVE_RESTAURANT,
            companyId: authType.getters.ACTIVE_COMPANY_ID,
            isRestaurantAdmin: authType.getters.IS_RESTAURANT_ADMIN,
            isCompanyAdmin: authType.getters.IS_COMPANY_ADMIN,
            managedRestaurants: restaurantType.getters.MANAGED_RESTAURANTS,
            refreshToken: authType.getters.GET_REFRESH_TOKEN,
        }),
        // the icon rail exists only next to the content; the mobile drawer opens in full
        isCollapsed() {
            return this.collapsed && this.$vuetify.breakpoint.mdAndUp
        },
        ordersRoute() {
            return this.isRestaurantAdmin
                ? { name: routeType.ORDER_ACTIVE }
                : { name: routeType.ORDER_LIST }
        },
        sidebarMenu() {
            return this.menu.filter((menuItem) => {
                let enabled = true

                if (menuItem.roles) {
                    // userHasRoles második paraméter, ha true, akkor a tömbben felsorolt összes role-nak meg kell felelnie a usernek
                    enabled = this.userHasRoles(menuItem.roles, true)
                } else if (menuItem.route) {
                    const route = this.routeRecursiveFind(
                        menuItem.route.name,
                        this.$router.options.routes
                    )

                    if (route?.meta?.requiresAuth && route?.meta?.roles) {
                        const roleIntersection = route.meta.roles.filter(
                            (item) => this.userRoles.includes(item)
                        )

                        enabled = roleIntersection.length > 0
                    }
                }

                if (
                    menuItem.custom_export_edit_required &&
                    !this.customExportEditEnabled
                ) {
                    enabled = false
                }

                if (
                    menuItem.custom_export_edit_required === false &&
                    this.customExportEditEnabled
                ) {
                    enabled = false
                }

                return enabled
            })
        },
        otterLinkRouteLinks() {
            return this.managedRestaurants
                .filter((r) => r?.externalType === 'otter' && !r?.externalId)
                .map((r) => {
                    return {
                        url: `${this.BeBaseURL}/connect-integration/otter/check?restaurant=${r.id}&token=${this.refreshToken}`,
                        name: r.name,
                    }
                })
        },
    },
    methods: {
        toggleCollapsed() {
            this.collapsed = !this.collapsed
            writeCollapsed(this.collapsed)
        },
        // a group's children are hidden in the icon rail, so opening one opens the sidebar
        expandSidebar() {
            if (this.isCollapsed) {
                this.toggleCollapsed()
            }
        },
        logout() {
            this.$store.dispatch(authType.actions.LOGOUT)

            if (this.$impersonate.state.isActive) {
                this.$impersonate.frontendLogout()
            }
        },
        routeRecursiveFind(findName, routes) {
            for (const route of routes) {
                if (route.name === findName) {
                    return route
                } else if (route.children) {
                    const result = this.routeRecursiveFind(
                        findName,
                        route.children
                    )
                    if (result) {
                        return result
                    }
                }
            }

            return null
        },
    },
}
</script>

<style lang="scss">
// 28px round, transparent, #181818 icon (merchant portal "Collapse navigation"); scoped under the
// drawer so it wins over the small icon button size
.v-application
    .ordit-navigation-drawer
    .ordit-navigation-drawer__toggle.v-btn.v-btn--icon {
    width: 28px;
    height: 28px;
    color: #181818;
}

//.theme--light.ordit-navigation-drawer {
//    background-color: var(--v-g-f5-base);
//    border-right: 1px solid var(--v-g-e8-base);
//}
.ordit-navigation-drawer {
    // the merchant portal app shell: the nav sits on the #f8f8f8 frame with the portal nav's 1px
    // #e9e9e9 divider on its right edge
    &.theme--light.v-navigation-drawer {
        background-color: #f8f8f8;
    }

    &.theme--light .v-navigation-drawer__border {
        width: 1px;
        background-color: #e9e9e9;
    }

    &__head {
        min-height: 32px;
        box-sizing: content-box;
    }

    &__toggle.is-collapsed {
        margin: 0 auto;
        transform: rotate(180deg);
    }

    // Vuetify hides only `no-action` group items in the mini variant
    &.v-navigation-drawer--mini-variant .v-list-group__items {
        display: none;
    }

    // sized after the DoorDash merchant portal onboarding sidebar: 256px wide, 16px side
    // padding, 40px rows 2px apart with an 8px radius, 24px icon, 12px gap,
    // 14px / 500 / 20px label, a light tint of the brand colour on the active row
    .ordit-nav {
        padding: 12px 16px 16px;
    }

    .ordit-nav .v-list-item {
        min-height: 40px;
        margin-bottom: 2px;
        padding: 8px;
        border: 0;
        border-radius: 8px;
        color: #191919 !important;

        &::before {
            border-radius: 8px;
        }

        // Vuetify's IE min-height helper would stretch the row past 40px
        &::after {
            display: none;
        }
    }

    .ordit-nav .v-list-group {
        border: 0;
    }

    .ordit-nav .v-list-item__icon {
        height: 24px;
        min-width: 24px;
        margin: 0 12px 0 0 !important;
        align-self: center;
    }

    .ordit-nav .v-list-item__content {
        padding: 0;
    }

    .ordit-nav .v-list-item__title {
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        letter-spacing: -0.01px;
    }

    .ordit-nav .v-list-item--active:not(.v-list-group__header) {
        // web2 highlight-subdued
        background-color: #e2f6d5;
        color: var(--v-primary-base) !important;

        &::before {
            opacity: 0;
        }
    }

    // a group's chevron sits at the row end, like the step status icons
    .ordit-nav
        .v-list-group__header
        .v-list-item__icon.v-list-group__header__append-icon {
        // the portal's 16px chevron in a 20px slot
        justify-content: center;
        align-items: center;
        min-width: 20px;
        height: 20px;
        margin: 0 0 0 8px !important;
    }

    .ordit-nav
        .v-list-group--active
        > .v-list-group__header
        .v-list-group__header__append-icon
        svg {
        transform: rotate(180deg);
    }

    .ordit-nav__child.v-list-item__content {
        padding-left: 36px;
    }

    &.v-navigation-drawer--mini-variant .ordit-nav .v-list-item__icon {
        margin-right: 0 !important;
    }

    &__account {
        padding: 16px;
        background-color: #f8f8f8;
    }

    &.v-navigation-drawer--mini-variant .ordit-account-pill {
        justify-content: center;
        padding: 7px;

        &[aria-expanded='true'] {
            padding: 6px;
        }
    }
}

.ordit-account-pill {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 8px;
    border: 1px solid #e7e7e7;
    border-radius: 8px;
    color: #191919;
    text-align: left;

    &:focus {
        outline: none;
    }

    &:focus-visible {
        box-shadow: 0 0 0 2px #fff, 0 0 0 4px rgba(25, 25, 25, 0.66);
    }

    // open menu: 2px accent border, the padding keeps the 42px height
    &[aria-expanded='true'] {
        padding: 7px;
        border: 2px solid var(--v-primary-base);
    }

    &__name {
        flex: 1;
        min-width: 0;
        margin: 0 8px;
        overflow: hidden;
        font-size: 14px;
        line-height: 20px;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}

.v-menu__content.ordit-account-menu {
    padding: 8px 0;
    border-radius: 8px;
    background-color: #fff;
    box-shadow: 0 4px 16px rgba(25, 25, 25, 0.2);
    contain: none;
}

.ordit-account-menu__item {
    display: flex;
    align-items: center;
    width: 100%;
    min-height: 40px;
    padding: 0 16px;
    color: #191919 !important;
    font-size: 14px;
    line-height: 20px;
    text-align: left;
    text-decoration: none;

    span {
        margin-left: 12px;
        white-space: nowrap;
    }

    &:hover {
        background-color: rgba(25, 25, 25, 0.04);
    }
}
</style>
